<!-- QRCodeGenerator.vue -->
<template>
  <div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QRCodeGenerator',
  props: {
	   itemWidth: {
	       type: Number,
	       default: 200
	   },
	   itemHeight: {
	       type: Number,
	       default: 200
	   }
	},
  data() {
    return {
      qrCodeUrl: '',
    };
  },
  mounted() {
	 this.orcodeAxios();
  },
  methods: {
	  orcodeAxios(){
	  	var that = this;
		var params = new URLSearchParams();
		params.append('version', '4');
	  	this.axios.post(this.GLOBAL.serverSrc+'mobile/tantan/zhuanfa/orcode',params)
	  	  .then(function (response) {
	  		  var datas = response.data.data;
	  		  if(response.data.code==1){
				 that.qrCodeUrl = "https://"+datas.address;
				 that.generateQRCode();
	  		  }
	  	  })
	  	  .catch(function (error) {
	  		  console.log(error);
	  	  });
	  },
	  generateQRCode() {
	  var that = this;
      const canvas = this.$refs.canvas
      QRCode.toCanvas(canvas, this.qrCodeUrl, {
        width: that.itemWidth,
        margin: 1,
        color: {
          dark: '#000000',      // 二维码颜色
          light: '#ffffff',   // 背景透明
        },
      }, (error) => {
        if (error) {
          //console.error('二维码生成失败:', error)
        } else {
          //console.log('二维码生成成功')
        }
      })
    },
  },
}
</script>

